module.exports = __webpack_public_path__ + "img/HZ-B5024.a1c3996e.jpg";